var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.productCategory)?_c(_setup.AzBreadcrumbs,{staticClass:"single-category",attrs:{"breadcrumbs":[_setup.productCategory],"is-mobile":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }